var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colelHoursDialog"},[_c('colelHours',{ref:"hours",attrs:{"colelProp":_vm.colelProp},on:{"close":function($event){_vm.isShow = false},"newHours":_vm.newHours}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }